import React, { forwardRef } from 'react';
import styles from './Benchmarks.module.scss';
import { Benchmark } from 'model/KidsHub';
import classnames from 'classnames';

interface BenchmarksProps {
  benchmarks: Pick<Benchmark, 'values' | 'columnName'>[];
  className?: string;
}

// eslint-disable-next-line react/display-name
const Benchmarks = forwardRef<HTMLDivElement, BenchmarksProps>(({ benchmarks, className }, ref) => {
  return (
    <div ref={ref} className={classnames(className, styles['benchmarks'])}>
      {benchmarks.map((benchmark) => (
        <div key={benchmark.columnName} className={styles['benchmark-item']}>
          <div className={styles['column-identifier']} />
          <div className={styles['benchmark-values']}>
            {benchmark.values.map((value, idx) => (
              <div key={idx} className={`${styles['benchmark-value']} body-small`}>
                {value !== null ? `${value}%` : ''}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
});

export default Benchmarks;
